import { appTypeConfig } from '../config'

export const isBulkOrderEnabled = () => !!appTypeConfig.isBulkOrderEnabled

/**
 * Resolve whether bulk order is allowed for this user on this host.
 * Page/host `config.isBulkOrderEnabled`: 'true' | 'false' | 'byEntitlement' (or missing → byEntitlement).
 * User `isBulkOrderEnabled`: 'true' | 'false' | 'byGroup' (or missing → byGroup).
 */
export const getIsBulkOrderEnabled = (user, config = {}) =>
  isBulkOrderEnabled() &&
  (config.isBulkOrderEnabled === 'true' ||
    (config.isBulkOrderEnabled !== 'false' &&
      (user?.isBulkOrderEnabled === 'true' ||
        (!!user?.group?.isBulkOrderEnabled && user?.isBulkOrderEnabled !== 'false'))))

/** View-only: manufacturer remark field on cart and detail pages. */
export const isBulkOrderRemarkEnabled = () =>
  appTypeConfig.isBulkOrderRemarkEnabled !== false

/** View-only: side switch, recap prefix, and cart/detail side column. */
export const isBulkOrderSideEnabled = () =>
  appTypeConfig.isBulkOrderSideEnabled !== false

/** opticalIndex above this value maps to *_HI_INDEX bulk-order material groups */
export const BULK_ORDER_HI_INDEX_THRESHOLD = 1.5

/** Maximum quantity per cart line (grid and cart page). */
export const MAX_CART_LINE_QUANTITY = 99

/** Max distinct lines per cart / submit (document size / abuse guard). */
export const MAX_CART_LINES = 1000

export const BULK_ORDER_MATERIAL_GROUPS = {
  MINERAL: 'MINERAL',
  MINERAL_HI_INDEX: 'MINERAL_HI_INDEX',
  ORGANIC: 'ORGANIC',
  ORGANIC_HI_INDEX: 'ORGANIC_HI_INDEX',
  TRIVEX: 'TRIVEX',
  POLYCARBONATE: 'POLYCARBONATE',
}

/** Fallback group key for catalog items with unmapped material */
export const BULK_ORDER_UNKNOWN_MATERIAL_GROUP = 'UNKNOWN'

export const BULK_ORDER_MATERIAL_GROUP_ORDER = [
  BULK_ORDER_MATERIAL_GROUPS.MINERAL,
  BULK_ORDER_MATERIAL_GROUPS.MINERAL_HI_INDEX,
  BULK_ORDER_MATERIAL_GROUPS.ORGANIC,
  BULK_ORDER_MATERIAL_GROUPS.ORGANIC_HI_INDEX,
  BULK_ORDER_MATERIAL_GROUPS.TRIVEX,
  BULK_ORDER_MATERIAL_GROUPS.POLYCARBONATE,
]

export const BULK_ORDER_COATING_FILTERS = {
  AR: 'AR',
  HC: 'HC',
  UC: 'UC',
}

export const COATING_FILTER_VALUES = [
  BULK_ORDER_COATING_FILTERS.AR,
  BULK_ORDER_COATING_FILTERS.HC,
  BULK_ORDER_COATING_FILTERS.UC,
]

export const BULK_ORDER_GRID_AXES = {
  CYLINDER: 'cylinder',
  ADDITION: 'addition',
}

export const BULK_ORDER_GRID_AXIS_VALUES = [
  BULK_ORDER_GRID_AXES.CYLINDER,
  BULK_ORDER_GRID_AXES.ADDITION,
]

export const BULK_ORDER_GRID_SIGNS = {
  PLUS: 'plus',
  MINUS: 'minus',
}

/** Focal types that use Sph × Addition grids instead of Sph × Cylinder. */
export const ADDITION_AXIS_FOCAL_TYPES = ['BIFOCALS', 'PROGRESSIVE']
